/**
 * Shared time-bucketing for the overview charts. Both the throughput and
 * storage-growth series bucket a timestamp column into fixed-width windows whose
 * size scales with the selected timeframe (see config/timeframes.ts `bucketMs`),
 * so a chart renders an accurate number of buckets at every range — 5-minute
 * buckets for "1h", weekly for "all time" — instead of always bucketing hourly.
 */

/** Floor a timestamp (ms) to the start of its bucket. */
export function bucketStartMs(tsMs: number, bucketMs: number): number {
  return Math.floor(tsMs / bucketMs) * bucketMs;
}

/** UTC label for a bucket start, chosen to read well at the given granularity. */
export function bucketLabel(startMs: number, bucketMs: number): string {
  const d = new Date(startMs);
  const mo = d.getUTCMonth() + 1;
  const day = d.getUTCDate();
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mm = String(d.getUTCMinutes()).padStart(2, '0');
  if (bucketMs < 3_600_000) return `${mo}/${day} ${hh}:${mm}`; // sub-hourly → M/D HH:MM
  if (bucketMs < 86_400_000) return `${mo}/${day} ${hh}:00`; // hourly → M/D HH:00
  return `${mo}/${day}`; // daily / weekly → M/D
}
